<template>
  <div class="deviceType popup">
    <div class="popup-content">
      <div class="header">
        请选择设备类型
        <img src="../assets/login/close.png" @click="close"/>
      </div>
      <div class="content">
        <div class="form-item" @click="choose">横屏</div>
        <div class="form-item" @click="choose">竖屏</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'deviceType',
    data(){
      return{
        deviceType:""
      }
    },
    methods:{
    //  关闭弹窗
      close:function(e){
        e.stopPropagation();
        this.$emit("close");
      },
    //  选择设备类型
      choose:function (e) {
        e.stopPropagation();
        var value=e.target.innerText;
        console.log(value);
        this.deviceType=value;
        this.$emit("choose",{type:0,deviceType:this.deviceType})
      }
    }
  }
</script>

<style scoped lang="scss">
</style>
